<template>
  <div class="home1">
    <div class="wrap">
      <div class="header">
        <h1 class="icon logo">
          <a
            class="wh100"
            href="javascript:;"
            @click="$router.push({ name: 'crossgate.tw' })"
            ><span class="none">永恒岛M</span></a
          >
        </h1>
        <ul class="nav">
          <li class="">
            <a
              href="javascript:;"
              @click="$router.push({ name: 'crossgate.tw' })"
              >官網首頁<br /><i>HOME</i></a
            >
          </li>
          <li class="">
            <a href="javascript:;">隱私政策<br /><i>PRIVACY POLICY</i></a>
          </li>
          <li class="">
            <a
              href="javascript:;"
              @click="$router.push({ name: 'crossgate.terms' })"
              >服務條款<br /><i>Terms Of Use</i></a
            >
          </li>
          <li class="">
            <a href="https://www.facebook.com/CrossGate.TW/" target="_black">
              <img :src="require('../../../../public/image/4.png')" alt="" />
            </a>
          </li>
          <li class="">
            <a href="https://discord.gg/wzMReVas33" target="_black">
              <img :src="require('../../../../public/image/5.png')" alt="" />
            </a>
          </li>
        </ul>
      </div>
      <div class="clearfix sectionInM">
        <div class="title">
          <a href="javascript:;" @click="$router.push({ name: 'crossgate.tw' })"
            >首頁</a
          ><span>&gt;</span>隱私政策
        </div>
        <div class="content">
          <div class="article">
            <div class="Section0" style="layout-grid: 15.6pt">
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">共和國科技</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  >有限公司（以下簡稱本公司）為保障您個人資料之安全性，特針對您個人的隱私權擬定本《個人資料暨隱私權保護政策》（Privacy&nbsp;Policy，下簡稱隱私權政策），讓您瞭解本公司對於您的隱私權之尊重與保護，並告訴您有關您個人資料之相關資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    為了確保您之個人資料及隱私及您權益之保護，本公司依照《個人資料保護法》等相關規定於蒐集前告知。本政策將長期於本公司網站進行公告，本政策進行修訂時，亦將以公告方式通知您，請您自行密切注意。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本政策讓您瞭解本公司在蒐集您的個人資料時：</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;本公司名稱及適用範圍。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;蒐集之目的及方式。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;蒐集之個人資料類別。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;個人資料利用之期間、地區、對象及方式。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >5.&nbsp;您得行使之權利及方式。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >6.&nbsp;若您無法提供完整的個人資料時，不提供將對您權益之影響。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >7.&nbsp;個人資料的安全維護。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >8.&nbsp;內容之變更通知。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">一、適用範圍</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本隱私權政策適用於您在本公司網站、應用程式</font
                  >
                  (APP)與其所附屬之網站活動及參與其他網路連線活動時，所涉及的個人資料蒐集、處理、利用、國際傳遞以及保護措施。但不適用於經本公司網站而連結至第三人經營的網站或網頁等。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">二、蒐集之目的及方式</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司之蒐集目的在於進行行銷、客戶管理、內部統計分析、會員管理及其他合於營業登記項目或章程所定業務之需要</font
                  >
                  &nbsp;(法定特定目的項目編號為040行銷、052會員管理、090消費者、客戶管理與服務、157調查、統計與研究分析、181其他經營合於營業登記項目或組織章程所定之業務)。&nbsp;蒐集方式將透過加入會員、各項服務表單填寫或訂購單填寫等方式進行，您可自行選擇是否提供資料及所提供資料的完整性，但某些網站、應用程式(APP)功能、服務或活動必須根據您所提供的資料方得使用；提請知悉，您若不提供完整而正確的個人資料，部分網站、應用程式(APP)功能、服務或活動可能無法使用。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">三、蒐集之個人資料類別</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.本公司在適用範圍內蒐集的個人資料包括</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >1）&nbsp;C001&nbsp;辨識個人者：如姓名、地址、電話、相片、電子郵件等。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >2）&nbsp;C002&nbsp;辨識財務者：如銀行帳戶之號碼等。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >3）&nbsp;C011&nbsp;個人描述：如年齡、性別、出生年月日等資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >4）&nbsp;C035&nbsp;休閒活動及興趣:如嗜好、運動等資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >5）&nbsp;C036&nbsp;生活格調:如使用消費品之種類及服務之細節等資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >6）&nbsp;C038&nbsp;職業:如司機、校長、老師等職業資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >7）&nbsp;C064&nbsp;工作經驗:如以前的工作、服役情形等工作資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font
                  >8）&nbsp;C132&nbsp;未分類之資料:如檔案、報告等資訊。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"></font>
                  （9）&nbsp;本公司將使用cookies進行網站管理及記錄您的活動紀錄、網站使用動態等。所謂cookies，為由本公司存放於您電腦中的瀏覽器目錄內，僅為本公司設置cookies的網站能讀取其內容。您可以透過您的瀏覽器設定以變更您cookies設置；您可以關掉Cookies，但可能會導致網站某些功能無法正常執行。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"></font>
                  （10）本公司網站及應用程式(APP)管理系統將紀錄您上網的IP位置、瀏覽器種類、使用時間及網站內所瀏覽的網頁記錄等軌跡資料，並依照《個人資料保護法》對相關軌跡資料進行保存。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;根據本公司所提供不同服務目的，本公司可能蒐集您的個人資料類別及情形如下：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(1)&nbsp;加入會員</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >當您申請加入會員時，您將會被要求填寫一份您的個人資料，包括姓名、性別、生日、電話、電子信箱等相關資料，並設定您的帳號密碼，以便您日後登入使用會員的各項服務。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(2)線上交易</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >如您選擇使用線上交易服務，將會依照您提出的線上交易形態，蒐集您所填寫的訂單相關資料，以確保您完成付款、儲值或物流等消費服務。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(3)&nbsp;線上活動、現場活動、賽事活動</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >您若因參加本公司舉辦之線上活動或網路調查而提供個人資料、會員帳號或密碼時，亦將一併受到隱私權政策之保護。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(4)&nbsp;瀏覽網頁</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">當您於本公司網站、應用程式</font>
                  (APP)或其附屬網站中瀏覽或查詢時，本公司伺服器將自動紀錄您使用連線之IP位置、時間及瀏覽相關記錄。這些資料僅供作流量統計分析及網路服務優化，以便於改善本公司的服務品質，這些資料僅作為總量上的分析，不會和特定個人相連繫。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(5)&nbsp;其他</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    除您直接提供的個人資料外，您也可能在本公司合作廠商處主動提供個人資料，並在您同意或為履行契約目的前提下，將您的個人資料提供給本公司。這些資料只會在您同意或為履行契約的服務範圍內利用及處理，不會用於其他用途。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.特殊或具敏感性的個人資料</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >我們不會要求您也請您不要提供特殊或具敏感性的個人資料給我們，例如您的病歷、醫療、政治、宗教、哲學信仰、種族、性取向、犯罪紀錄或基因等。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.您可以自由選擇是否提供您的個人資料給我們，但請您知悉，如未提供足夠資料者（除本條第3款載明的無需提供的特殊或具敏感性的個人資料），部分服務將無法為您提供，敬請見諒。建議您提供完整的個人資料並隨時更新，若因您未提供完整且確實的個人資料，造成您或第三人發生損害時，您應自行負擔一切責任。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >四、個人資料利用之期間、地區、對象及方式</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;利用期間</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司將於營運期間保存您的個人資料，除法令另有規定者外，於您使用本公司網站、應用程式</font
                  >
                  (APP)&nbsp;或其所附屬網站服務完畢或至您提出停止使用之請求為止。如您欲刪除或移除個人資料，請循本公司官網的聯絡方式與我們聯繫。參加活動者之個人資料使用自活動參與者授權參與活動起始日至活動結束後三(3)個月。依據稅法規定，活動得獎者之個人資料最長保存七(7)年，屆時銷毀，不作他用。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;利用地區</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >中華民國（台灣）地區及提供本公司網站、應用程式</font
                  >
                  (APP)與其所附屬網站服務之地區。&nbsp;您之個人資料將用於全球。您應知悉，當您將個人資料提供予我們時，您的個人資料皆將可能在我們位處各國的關係企業、服務供應商、經授權的協力廠商廠商和承包商間進行跨境傳輸、儲存及處理利用；上述跨境傳輸、儲存及處理利用行為皆將遵循本協定及各國個人隱私及資訊安全之相關法令要求。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;利用對象</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    除法令另有規定者外，本公司將僅供您同意之服務目的及本公司內部在相關連之範圍內使用，不會任意將您提供的個人資料轉供其他第三人或移作其他目的使用。但基於履行契約目的，本公司將提供相關資料予協辦單位或合作廠商，以完成履行契約義務。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;利用方式</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >基於上述蒐集目的，您的個人資料除用於本公司之會員行銷、客戶管理、內部的統計調查與分析、會員管理等方式以外，本公司將依您的實際需要，將您個人資料利用如下：
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font>1）資料管理 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    當您申請加入會員時，您將會被要求填寫一份您的個人資料，包括姓名、性別、生日、電話、住址、電子信箱等相關資料，並設定您的帳號密碼，以便您日後登入使用您的各項服務。您在加入會員時所填寫的資料，本公司將會進行手機及 </font
                  >e-mail驗證，並用於分析您個人的線上消費行為，以作為將來提供您所需之詳盡資料以及作為設計您活動時之依據。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font>2）線上交易 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >如您選擇使用線上交易服務，本公司將會依照您提出的線上交易形態，蒐集您所填寫的訂單相關資料、金融交易過程</font
                  >
                  (如信用卡授權、轉帳)時直接提交給金融機構以完成金融交易，以確保您完成付款、儲值或物流等消費服務。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font>3）統計與分析 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">當您於本公司網站、應用程式</font>
                  (APP)或其附屬網站中瀏覽或查詢時，本公司伺服器將自動紀錄您使用連線之IP位置、時間及瀏覽相關記錄。這些資料僅供作統計分析及網路服務優化，以便於改善本公司的服務品質，本公司可能針對您提供的資料，以及站內瀏覽時伺服器所產生的紀錄，不定期對這些資料進行總體分析與統計，但不會和特定個人相連繫。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font>4）&nbsp;遊戲行銷 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司將利用您之地址、郵件、電話號碼進行本公司或合作廠商商品之行銷宣傳，並為此完善向您提供的遊戲服務。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font>5）會員服務 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司將利用您所提供之各項資料提供予您各項服務及福利，具體包括：</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >a.&nbsp;訂閱電子報</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">當您使用本公司網站、應用程式</font
                  >(APP)與其所附屬網站服務，您可能會收到相關電子報。若您欲取消訂閱，請洽本公司客服專線或本公司線上回報系統與我們聯繫。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >b.&nbsp;線上活動、現場活動、賽事活動</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >您若因參加本公司舉辦之線上活動或網路調查所留下的個人資料，僅供該次活動或調查使用。這些資料將於活動或調查結束後銷毀。這些資料將於活動或調查結束後一定時間內銷毀。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >c.&nbsp;虛擬、寶物及贈品寄送</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >於交寄相關商品時，將您的個人資料利用於交付給相關物流、郵寄廠商用於物品寄送之目的。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >d.&nbsp;其他會員服務</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司將利用您所提供之各項資料提供其他各項會員服務，包括本公司所提供的服務及產品之市場研究報告、定期通訊、活動邀請、市場訊息等。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">（</font>6）政府行政或司法之所需 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >基於政府單位之通知，本公司將提供您於本遊戲中之所有個人資料。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >五、個人資料行使之權利及方式</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.您交付個人資料予本公司，依《個人資料保護法》得行使以下權利：</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(1)&nbsp;查詢或請求閱覽。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(2)&nbsp;請求製給電子版複製本。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(3)&nbsp;請求補充或更正。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(4)&nbsp;請求停止蒐集、處理或利用。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >(5)&nbsp;請求刪除。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    以上權利，若因您不符合本公司申請程式或法令另有規定時，將會受到限制。提請知悉，若您就您的個人資料向本公司查詢、請求閱覽個人資料或製給電子版複製本時，本公司將酌收必要成本費用。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.您如欲行使上述權利，您可循本公司官網的聯絡方式與我們聯繫並進行申請&nbsp;。請您知悉，為保護您的隱私，申請時您需填具申請檔，我們可以向您請求提供可資確認之身份證明檔，因您未提供或提供不實數據情形時，以致於無法確認您的身份真實性的，我們將無法處理您的請求。若委託他人代為申請者，應出具委任書，並提供本人及代理人可資確認之身份證明文件。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">六、您應提供正確的個人資料</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">
                    所有關於您的個人資料之欄位請務必確實填寫，若您無法提供完整且確實的個人資料，將影響本公司和您的聯繫、完成交易、提供服務、身份驗證或處理消費、交易或客訴問題，建議您應提供完整的個人資料及隨時更新。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >若您未提供完整且確實個人資料，對您及第三人造成損害時，您應負擔一切責任。如未來因您提供的不實資料發生爭議</font
                  >
                  (例如偽冒身分)，本公司將視狀況進行法律訴追。如造成本公司損失的，本公司有權向您請求損害賠償。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">七、安全維護</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >關於您的個人資料檔案，本公司將採行適當之安全措施，並盡力以合理之技術及措施，依相關法令辦理安全維護事項，防止您的個人資料被竊取、竄改、毀損、滅失或洩漏。
                  </font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >我們會保護您的個人資料不會被披露，但如遇有下列情形，本公司將保留公開您個人資料的權利予特定人：</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.您或其監護人授權本公司披露、使用或提供的；</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.違反本公司網站或產品之使用者條款等的；或因您的行為對本公司之網站、權利、產品或其他用戶造成損害或干擾的；或受損害干擾人因而對您採取法律行動的；</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.法律訴訟及/或強制執行判決及/或命令；及/或</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.為遵守有關法律規範或主管機關命令的。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">八、自我保護措施</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.&nbsp;請妥善保管您的密碼及/或您的任何個人資料，不要將您的個人資料提供給任何人，建議您的密碼避免設定為與其他的遊戲、網站、應用程式(APP)、信箱、社群、論壇的密碼相同。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.&nbsp;在您完成繳費、取閱電子郵件、結束遊戲等程式後，務必記得登出帳戶，若您與他人共用電腦或使用公共電腦，切記要關閉瀏覽器視窗或消除瀏覽記錄等，以防止他人讀取您的個人資料或信件。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >3.&nbsp;避免開啟來路不明的網站及其附件檔案；不要安裝或執行來路不明之程式，或前往外掛網站、論壇等，以防止您資料的外洩與避免電腦遭木馬程式或其他病毒植入之機會。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >4.&nbsp;官方人員、活動人員及線上遊戲管理人員等，皆不會主動向任何玩家要求密碼資料，不論是任何理由皆是不被允許的，若發現有此類情況，請您立即回報給本公司進行處理。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">九、隱私權政策變更</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本隱私權政策的解釋、修改及更新權均屬於本公司所有。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司有權自行修訂本隱私權政策，相關修正將會公告於本網站或應用程式</font
                  >(APP)內，或以電子郵件方式通知您，請您密切注意以保障個人權益。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >如果您不同意本隱私權政策及其變更之內容，請您立即停止使用本公司網站、應用程式</font
                  >
                  (APP)與其所附屬之網站服務。本隱私權政策將長期於本公司網站進行公告，須請您自行密切注意；當您於隱私權政策變更後繼續使用本公司服務，表示您已同意本隱私權政策及其變更之內容。 </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">十、安全聲明</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >1.我們將通過合理步驟確保個人資料安全。儘管我們會採取安全防護和預防措施，但還是存在著您的個人資料可能會被未授權的協力廠商廠商看到的風險，或受到電腦病毒的攻擊及其它安全隱患。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >2.若您通過本網站連結至其它網站，則請知悉協力廠商廠商網站不受本公司管轄，本公司亦不對其行為負責。請注意：您自身提供給協力廠商廠商的個人資料不受本隱私權政策制約，我們強烈建議您仔細瞭解協力廠商廠商隱私和安保方面的協議或條款。</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >任何情況下，請您注意小心妥善保管個人資料，若因您自身原因導致您個人資料或隱私洩露或給您造成損失或其他不利影響的，本公司對此不承擔任何責任。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">十一、效力等級</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >本公司有權自行修訂本《個人資料保護政策》之內容，包括為配合相關法令之異動。本隱私權政策若存在與您所在地的法律法規不一致的條款，請以當地法律法規為準。</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">十二、看法與建議</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p
                class="p"
                align="justify"
                style="
                  margin-top: 5pt;
                  margin-right: 0pt;
                  margin-bottom: 5pt;
                  margin-left: 0pt;
                  mso-pagination: widow-orphan;
                  text-align: justify;
                  text-justify: inter-ideograph;
                "
              >
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU"
                    >您如果對本公司的隱私權政策或與您個人資料有關之事項有任何意見或疑問，歡迎您透過本公司客服信箱【</font
                  > </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(255, 0, 0);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                  >crossgate.tw.cs@gmail.com</span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: PMingLiU;
                    color: rgb(51, 51, 51);
                    letter-spacing: 0pt;
                    font-weight: normal;
                    font-style: normal;
                    font-size: 10pt;
                    mso-font-kerning: 1pt;
                  "
                >
                  <font face="PMingLiU">】與我們聯繫。</font> </span
                ><span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 12pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
              <p class="MsoNormal">
                <span
                  style="
                    mso-spacerun: 'yes';
                    font-family: Calibri;
                    mso-fareast-font-family: 宋体;
                    mso-bidi-font-family: 'Times New Roman';
                    font-size: 10.5pt;
                    mso-font-kerning: 1pt;
                  "
                >
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <!-- <p>香港鈴六網絡科技有限公司</p>
            <p>Guangzhou Lulin Technology Co. LTD</p>
            <p>广州市天河区棠下荷光三横路13号301房</p> -->
      <div class="leftP">
        <img :src="require('../../../../public/image/12.png')" alt="" />
        <img :src="require('../../../../public/image/11.png')" alt="" />
      </div>
      <div class="rightP">
        <div class="pwarp">
          <p>※本軟體因涉及暴力、打鬥，依遊戲軟體分級管理辦法分類為輔12級</p>
          <p>※遊戲內提供購買虛擬遊戲幣、物品等付費服務</p>
          <p>※請注意遊戲時間，避免沉迷</p>
          <p>※共和國科技有限公司為在台港澳地區的授權代理商。</p>
        </div>
      </div>

      <!-- <p>香港鈴六網絡科技有限公司</p>
        <p>LINGLUK NETWORK TECHNOLOGY LIMITED</p>
        <p>
          Room 101A, 1/F., Genplas Industrial Building, 56 Hoi Yuen Road, Kwun
          Tong, Kowloon
        </p> -->
    </div>
  </div>
</template>

<script>
import '../../../../public/js/jquery.min.js'
export default {
  name: 'crossgatePolicy',
  mounted() {
    $('#focus .imgs ul').width(
      $('#focus .imgs li').length * $('#focus').width()
    )
    $('#focus .ctrl a:eq(0)').addClass('on')
    var focusT

    function focus() {
      focusT = setInterval(function () {
        var i = $('#focus .ctrl a.on').index('#focus .ctrl a') || 0,
          l = $('#focus .ctrl a').length
        i++
        if (i > l - 1) i = 0
        $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
        $('#focus .imgs ul')
          .stop(true, true)
          .animate(
            {
              left: -$('#focus').width() * i
            },
            600
          )
      }, 8000)
    }
    focus()
    //幻灯
    $('#focus .ctrl a').click(function () {
      clearInterval(focusT)
      var i = $(this).index('#focus .ctrl a')
      $('#focus .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#focus .imgs ul')
        .stop(true, true)
        .animate(
          {
            left: -$('#focus').width() * i
          },
          600,
          function () {
            focus()
          }
        )
    })

    $('.sectionC .next,.sectionC .prev').click(function () {
      var i = $('.sectionC .ctrl a.on').index() || 0,
        l = $('.sectionC .ctrl a').length
      if ($(this).hasClass('next')) {
        i++
        if (i > l - 1) i = 0
      } else {
        i--
        if (i < 0) i = l - 1
      }
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //特色
    $('.sectionC .ctrl a').click(function () {
      var i = $(this).index()
      $('.sectionC .ctrl a').removeClass('on').eq(i).addClass('on')
      $('.sectionC .imgs li').removeClass('on').eq(i).addClass('on')
    })
    //场景
    $('#scene .ctrl a').click(function () {
      var i = $(this).index('#scene .ctrl a')
      $('#scene .ctrl a').removeClass('on').eq(i).addClass('on')
      $('#scene .imgs li').hide().eq(i).fadeIn(800)
    })
    $('.sider a').click(function () {
      var i = $(this).index()
      if (i < 4) {
        $('html,body').animate(
          {
            scrollTop: $('.section').eq(i).offset().top
          },
          500
        )
      }
    })

    function play_image_list(elementID, effect, play_time) {
      var _div = $('.' + elementID + ' ul')
      var temp_time
      if (_div.children('li').length <= 4) {
        return false
      }
      //play_img("left");
      _div.width(
        _div.children('li').length * (_div.children('li').eq(0).width() + 20)
      )
      if (effect === 'continue') {
        play_time = 30
        _div.css('margin-left', '0px')
      }
      temp_time = setTimeout(function () {
        play_img('left')
      }, play_time)
      _div.parent().hover(
        function () {
          clearTimeout(temp_time)
        },
        function () {
          temp_time = setTimeout(function () {
            play_img('left')
          }, play_time)
        }
      )

      function play_img(type) {
        if (temp_time) {
          clearTimeout(temp_time)
        }
        var div_f = $('.' + elementID + ' ul>li:first'),
          div_l = $('.' + elementID + ' ul>li:last'),
          div_width = div_f.width()
        //alert(div_width);
        if (effect === 'continue') {
          play_time = 30
          var num =
            _div[0].style.marginLeft == '0px'
              ? parseInt(_div[0].style.marginLeft)
              : parseInt(_div[0].style.marginLeft.substring(1))
          num++
          if (num <= div_width + 20) {
            _div.css('margin-left', -num + 'px')
          } else {
            _div.append(div_f)
            _div.css('margin-left', '0px')
          }
        }
        temp_time = setTimeout(function () {
          play_img('left')
        }, play_time)
        return false
      }
    }

    function minWidth() {
      var isIE6 = !-[1] && !window.XMLHttpRequest
      //if(!isIE6){return false;}
      var num = 980
      var w_width = $(window).width()
      if (w_width > num) {
        $('body').width('100%')
      } else {
        $('body').width(980)
      }
    }
    play_image_list('logs', 'continue', 4000)
    var my_jPlayer

    function scrollTxt() {
      var controls = {},
        values = {},
        t1 = 300,
        /*播放动画的时间*/
        t2 = 4000,
        /*播放时间间隔*/
        si
      controls.rollWrap = $('#roll-wrap')
      controls.rollWrapUl = controls.rollWrap.children()
      controls.rollWrapLIs = controls.rollWrapUl.children()
      values.liNums = controls.rollWrapLIs.length
      values.liHeight = controls.rollWrapLIs.eq(0).height()
      values.ulHeight = controls.rollWrap.height()
      this.init = function () {
        autoPlay()
        pausePlay()
      }
      /*滚动*/
      function play() {
        controls.rollWrapUl.animate(
          {
            'margin-top': '-' + values.liHeight
          },
          t1,
          function () {
            $(this).css('margin-top', '0').children().eq(0).appendTo($(this))
          }
        )
      }

      /*自动滚动*/
      function autoPlay() {
        /*如果所有li标签的高度和大于.roll-wrap的高度则滚动*/
        if (values.liHeight * values.liNums > values.ulHeight) {
          si = setInterval(function () {
            play()
          }, t2)
        }
      }

      /*鼠标经过ul时暂停滚动*/
      function pausePlay() {
        controls.rollWrapUl.on({
          mouseenter: function () {
            clearInterval(si)
          },
          mouseleave: function () {
            autoPlay()
          }
        })
      }
    }
    new scrollTxt().init()
  }
}
</script>

<style lang='scss' scoped src='../../../../public/css/home.css'></style>
<style lang='scss' scoped src='../../../../public/css/copy.css'></style>
<style lang='scss' scoped src='../../../../public/css/black.css'></style>
<style lang="scss" scoped>
.center {
  position: relative;
  height: 100%;
}
.centerBody {
  position: absolute;
  padding: 10px;
  border: 2px solid #fff;
  border-radius: 10px;
  background: rgba($color: #000000, $alpha: 0.5);
  bottom: 50px;
  left: 50%;
  width: 80%;
  transform: translateX(-50%);
  display: block;
  height: 150px;
  .leftWarp {
    float: left;
    div {
      a {
        display: block;
        img {
          width: 50%;
          padding: 5px;
          box-sizing: border-box;
          display: inline-block;
          float: left;
        }
      }
    }
  }
  .rightWarp {
    padding: 0px;
    position: relative;
    padding-left: 50px;
    height: 100%;
    div {
      height: 150px;
      border: 1px solid #fff;
      border-radius: 5px;
      box-sizing: border-box;
      a {
        display: block;
        width: 100%;
        height: 100%;
        img {
          padding: 5px;
          width: 100%;
          height: 100%;
          // height: 100%;
          display: block;
          box-sizing: border-box;
        }
      }
    }
  }
}
.sectionA {
  height: calc(100vw * 1440 / 2560 - 90px - 120px);
}
.footer {
  display: block;
  text-align: center;

  .leftP {
    // float: left;
    display: inline-block;
    height: 120px;
    // width: 50%;
    overflow: hidden;
    vertical-align: middle;
    img {
      width: 80px;
      height: 80px;
      float: right;
      padding: 20px 10px;
    }
  }
  .rightP {
    height: 120px;
    display: inline-block;
    text-align: left;
    vertical-align: middle;
    overflow: hidden;
    .pwarp {
      display: inline-block;
      overflow: hidden;
      padding: calc((120px - 72px) / 2);
      padding-left: 10px;
    }
    p {
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/crossgateTw/policy/index.vue